import type {
  RawData,
  TestDefinition,
  TestResult,
  ValidationResult,
} from '../types.ts';
import {
  errorText,
  formatHash,
  formatError,
  result,
  validation,
  validationError,
} from './shared.ts';

function context2d(): CanvasRenderingContext2D {
  const context = document.createElement('canvas').getContext('2d');
  if (!context) {
    throw new Error('Canvas 2D is unavailable');
  }
  return context;
}

function rectValues(rect: DOMRect | DOMRectReadOnly): number[] {
  return [
    rect.x,
    rect.y,
    rect.width,
    rect.height,
    rect.top,
    rect.right,
    rect.bottom,
    rect.left,
  ];
}

async function collect(): Promise<RawData> {
  const container = document.createElement('div');
  container.style.cssText =
    'position:fixed;left:11.25px;top:13.5px;width:240.5px;font:16px Arial;transform:translate(.25px,.5px);visibility:hidden';
  container.textContent = 'ABC Привет 😀 geometry';
  document.body.append(container);
  const range = document.createRange();
  range.selectNodeContents(container);
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  const circle = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'circle',
  );
  circle.setAttribute('cx', '40');
  circle.setAttribute('cy', '30');
  circle.setAttribute('r', '12');
  svg.append(circle);
  document.body.append(svg);
  try {
    const context = context2d();
    context.font = '16px Arial';
    return {
      domRects: { container: rectValues(container.getBoundingClientRect()) },
      rangeRects: {
        range: rectValues(range.getBoundingClientRect()),
      },
      svgRects: {
        circle: (() => {
          const box = circle.getBBox();
          return [box.x, box.y, box.width, box.height];
        })(),
      },
      textMetrics: { russian: [context.measureText('Привет').width] },
      emojiMetrics: { emoji: [context.measureText('😀').width] },
      transformMetrics: {
        container: rectValues(container.getBoundingClientRect()),
      },
    };
  } finally {
    range.detach();
    container.remove();
    svg.remove();
  }
}

function format(rawData: RawData): string {
  const error = formatError(rawData);
  if (error) {
    return error;
  }
  return formatHash(rawData);
}

async function run(): Promise<TestResult> {
  let rawData: RawData;
  try {
    rawData = await collect();
  } catch (error) {
    rawData = { error: errorText(error) };
  }
  return result(rawData, format);
}

function validate(rawData: RawData): ValidationResult {
  const error = validationError(rawData);
  if (error) {
    return error;
  }
  return validation([]);
}

export const domSvgGeometryTest: TestDefinition = {
  id: 'domSvgGeometry',
  title: 'DOM / SVG geometry',
  category: 'shared',
  format,
  run,
  validate,
};
